import { Signal } from "signals";
import { IIntegrationWrapper, IWrapperMediator } from "slotworks/integration/revolver/wrapper/wrapper-mediator";
import { InitRecordSchema } from "../revolver/schema/init-record-schema";
import { SpinResponseSchema } from "../revolver/schema/spin-record-schema";
import { WrapperEvent } from "../revolver/wrapper/WrapperEvent";
import { StopAutoplayCommand } from "slotworks/commands/autoplay/stop-autoplay";
import betModel from "slotworks/model/bets/bet-model";
import gameState from "slotworks/model/game-state";
import currency from "slotworks/i18n/currency";
import soundManager from "slotworks/sound/sound-manager";

export class RelaxSEWrapper implements IIntegrationWrapper, IWrapperMediator {
    public events = new Signal();
    protected wrapper:any;

    public constructor() {
        if ("RgPostMessageAPI" in window) {
            // @ts-ignore
            this.wrapper = window.RgPostMessageAPI;

            window.addEventListener(​ 'rg_pause'​ , (event: any) =>
            {
                if(event.data && event.data.autoPlayOnly) {
                    /* If ​ event.data.autoPlayOnly​ is true, only pause autoPlay. */
                    StopAutoplayCommand();
                } else {
                    /* A hard pause. Once any unfinished round has completed, disable
                    controls(so a new round cannot be started), pause autoplay, and
                    call ​ RgPostMessageAPI.reportPaused().​ */
                    StopAutoplayCommand();
                    this.pauseGame();
                }
            });

            window.addEventListener(​ 'rg_resume'​ , () =>
            {
                /* Reality check was closed; the game can now continue.
                Re-enable controls and resume autoplay if it was paused by
                'rg_pause' */
                this.resumeGame();
            });
        }
    }

    public pauseGame() {
        this.events.dispatch(WrapperEvent.Pause,{waitForSpinFinish: true});
    }

    public resumeGame() {
        this.events.dispatch(WrapperEvent.Resume);
    }

    public dispose = () => {
        if (this.wrapper) {
            this.wrapper.pauseGame = () => {};
            this.wrapper.resumeGame = () => {};
        }

        this.events.removeAll();
        this.events = null;
    }

    // IWrapperMediator implementation
    public init = () => {
        this.wrapper.init(true);
    }
    public gameLoaded = () => {
        this.wrapper.reportGameReady();
        
        this.wrapper.reportSettings({currency: currency.getCurrency(), enableSounds: !soundManager.getMuted()});
        soundManager.onMuteChange.add((muted: boolean) => {
            this.wrapper.reportSettings({currency: currency.getCurrency(), enableSounds: !muted});
        });
    }

    public reportPaused = () => {
        this.wrapper.reportPaused();
    }

    public roundStarted = (spinId: number, balanceBefore: number) => {
        const balance = gameState.getCurrentGame().balance;
        this.wrapper.gameRoundStarted({balance: balance});
    }

    public roundEnd = (win: number, bet: number, balance: number) => {    
        this.wrapper.gameRoundEnded({balance: balance, bet: bet, win: win});
    }

    public quit = () => {}
    public gameDataLoaded = (response: InitRecordSchema) => {}
    public roundStart = (totalBet: number, balance: number) => {}    
    public spinResponseReceived = (response: SpinResponseSchema) => {}
    public balanceUpdated = (balance: number) => {}
    public autoplayStart = () => {};
    public autoplayEnd = () => {};
}



// WEBPACK FOOTER //
// ./~/slotworks/integration/relax/RelaxSEWrapper.ts